export const RATING_ICON_WIDTH_LARGE = 24;
export const RATING_ICON_WIDTH = 16;

export enum RatingVariant {
  allStars = 0,
  singleStar,
  /* i.e. single star on mobile; all stars on other viewports */
  variable,
}
